// extracted by mini-css-extract-plugin
export default {"image-wrapper":"LoadingIcon_image-wrapper__vQAZZ","image":"LoadingIcon_image__MzJ7V"};